// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useContext, useRef, useState } from 'react';
// others block
import { PrimaryDots } from '../../assets/images';
import { AppContext, AuthContext } from '../../context';
import { ActionType } from '../../context/AppContextReducer';
import { LawTypeMenuProps } from '../../interfaceTypes';
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants';
import { LawTypeActionType } from '../lawType/LawTypeReducer';

export const LawTypeMenu: FC<LawTypeMenuProps> = ({ lawType, dispatch }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const { isEdit, dispatch: appDispatch, isDeleteOpen } = useContext(AppContext)
  const { isAdmin } = useContext(AuthContext)
  const { id: lawTypeId } = lawType || {}

  const handleClick = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  const anchorRef = {
    [lawTypeId!]: useRef<HTMLButtonElement>(null),
  };

  const handleViewModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    dispatch({ type: LawTypeActionType.SET_CURRENT_LAW_TYPE, currentLawType: lawType })
  }

  const handleDeleteModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    dispatch({ type: LawTypeActionType.SET_CURRENT_LAW_TYPE, currentLawType: lawType })
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[lawTypeId!]}
        id={`long-button-${lawTypeId}`}
        aria-controls={`long-menu-${lawTypeId}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${lawTypeId}`}
        anchorEl={anchorRef[lawTypeId!].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem onClick={handleViewModal}>View</MenuItem>

        {isAdmin && <MenuItem onClick={handleDeleteModal} color='primary.main'>Delete</MenuItem>}
      </Menu>
    </Box>
  );
};
